
export const ServerInfo = server => ({
  type: 'SERVER_INFO',
  server
})

